import React from 'react'
import Walletreruestcom from '../Component/Walletreruestcom'

const WalletReruest = () => {
  return (
    <div>
        <Walletreruestcom/>
    </div>
  )
}

export default WalletReruest